module.exports = __webpack_public_path__ + "media/images/banner/klook/pc/rental-o_770_280_th-dd40b6c3331fe0f88889756eccbe9f96.jpg";